import { FC, useState } from 'react';
import { Modal, FormInput, FormCheckbox } from '@praktio/common-ui';
import { useDispatch } from 'react-redux';

import { sendTeamWelcomeEmail } from '../../ducks/teams';
import { sendUserWelcomeEmail } from '../../ducks/users';

interface ComponentProps {
  onHide: () => void;
  show: boolean;
  teamId?: string;
  userId?: string;
}

const SendWelcomeEmailModal: FC<ComponentProps> = ({ onHide, show, teamId, userId }) => {
  const dispatch = useDispatch();
  const [confirm, setConfirm] = useState('');
  const [includeAll, setIncludeAll] = useState(false);
  const [includeSubteams, setIncludeSubteams] = useState(false);

  const hideAndClear = () => {
    onHide();
    setConfirm('');
    setIncludeAll(false);
    setIncludeSubteams(false);
  };

  const disable = confirm !== 'SEND';
  return (
    <Modal
      title="Send Welcome Emails"
      description={`Are you sure you want to send a welcome email?`}
      onSave={() => {
        if (!disable) {
          if (teamId) {
            dispatch(sendTeamWelcomeEmail(teamId, includeAll, includeSubteams));
          } else if (userId) {
            dispatch(sendUserWelcomeEmail(userId));
          }
        }
        hideAndClear();
      }}
      onHide={() => {
        hideAndClear();
      }}
      show={show}
      saveText="SEND"
      disableSave={disable}
    >
      {teamId && (
        <>
          <div>
            Emails will be sent to all Learners that have not logged in yet unless checkbox below is
            selected.
          </div>
          <FormCheckbox
            id="all-learners"
            label="Include All Team Learners"
            checked={includeAll}
            onChange={() => setIncludeAll(!includeAll)}
          />
          <FormCheckbox
            id="include-subteams"
            label="Include Subteams"
            checked={includeSubteams}
            onChange={() => setIncludeSubteams(!includeSubteams)}
          />
        </>
      )}
      <FormInput
        label="Type 'SEND' to confirm"
        value={confirm}
        onChange={(e: any) => setConfirm(e.target.value)}
      />
    </Modal>
  );
};

export default SendWelcomeEmailModal;
